<template>
  <WdsText class="tw-truncate" :text="date" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const StaffingAgencyClientAddedColumn = graphql(`
  fragment StaffingAgencyClientAddedColumn on SupplierClient {
    id
    createdAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof StaffingAgencyClientAddedColumn>
}>()

const column = computed(() => useFragment(StaffingAgencyClientAddedColumn, props.row))
const { date } = useDate(computed(() => column.value.createdAt))
</script>
